import { createReducer } from "@reduxjs/toolkit";
import {
	API_GET_FOLDERS_TO_VALIDATE,
	API_GET_FOLDERS_TO_VALIDATE_FAIL,
	API_GET_FOLDERS_TO_VALIDATE_SUCCESS,
	API_GET_FOLDERS_FUTURE,
	API_GET_FOLDERS_FUTURE_FAIL,
	API_GET_FOLDERS_FUTURE_SUCCESS,
	API_GET_FOLDERS_PAUSED,
	API_GET_FOLDERS_PAUSED_FAIL,
	API_GET_FOLDERS_PAUSED_SUCCESS,
	API_GET_FOLDERS_COUNT_SUCCESS,
	API_GET_FOLDERS_COUNT_FAIL,
} from "actions/folder";
import { ErrorAction, errorHandler } from "utils/error";
import { SET_OPEN_TAB, SET_TV_SEC_MODE } from "actions/secretaryMode";

const initialState = {
	tvSecMode: "",
	openedTab: 0,
	count: {
		toValidate: 0,
		futures: 0,
		paused: 0,
	},
	toValidate: {
		list: [],
		loading: false,
		pages: 0,
		listTotalCount: 0,
		page: 1,
		prescriptionCount: 0,
	},
	futures: {
		list: [],
		loading: false,
		pages: 0,
		listTotalCount: 0,
		page: 1,
		prescriptionCount: 0,
	},
	paused: {
		list: [],
		loading: false,
		pages: 0,
		listTotalCount: 0,
		page: 1,
		prescriptionCount: 0,
	},
};

const secretaryMode = createReducer(initialState, {
	/** GET ALL TO VALIDATE **/
	[API_GET_FOLDERS_TO_VALIDATE]: (state, action) => {
		state.toValidate.loading = true;
	},
	[API_GET_FOLDERS_TO_VALIDATE_FAIL]: (state, action) => {
		errorHandler("Prescription à valider", ErrorAction.READ, action.error);
		state.toValidate.loading = false;
		state.toValidate.list = [];
		state.toValidate.pages = 0;
		state.toValidate.listTotalCount = 0;
		state.toValidate.prescriptionCount = 0;
		state.toValidate.page = 1;
	},
	[API_GET_FOLDERS_TO_VALIDATE_SUCCESS]: (state, action) => {
		state.toValidate.loading = false;
		state.toValidate.list = action.payload.data.results;
		state.toValidate.pages = action.payload.data.numberOfPages;
		state.toValidate.listTotalCount = action.payload.data.totalCount;
		state.toValidate.prescriptionCount = action.payload.data.prescriptionCount;
		state.toValidate.page = action.payload.data.page;
	},
	/** GET ALL FUTURES **/
	[API_GET_FOLDERS_FUTURE]: (state, action) => {
		state.futures.loading = true;
	},
	[API_GET_FOLDERS_FUTURE_FAIL]: (state, action) => {
		errorHandler("Prescription à saisir", ErrorAction.READ, action.error);
		state.futures.loading = false;
		state.futures.list = [];
		state.futures.pages = 0;
		state.futures.listTotalCount = 0;
		state.futures.prescriptionCount = 0;
		state.futures.page = 1;
	},
	[API_GET_FOLDERS_FUTURE_SUCCESS]: (state, action) => {
		state.futures.loading = false;
		state.futures.list = action.payload.data.results;
		state.futures.pages = action.payload.data.numberOfPages;
		state.futures.listTotalCount = action.payload.data.totalCount;
		state.futures.prescriptionCount = action.payload.data.prescriptionCount;
		state.futures.page = action.payload.data.page;
	},
	/** GET ALL PAUSED **/
	[API_GET_FOLDERS_PAUSED]: (state, action) => {
		state.paused.loading = true;
	},
	[API_GET_FOLDERS_PAUSED_FAIL]: (state, action) => {
		errorHandler("Prescription à saisir", ErrorAction.READ, action.error);
		state.paused.loading = false;
		state.paused.list = [];
		state.paused.pages = 0;
		state.paused.listTotalCount = 0;
		state.paused.prescriptionCount = 0;
		state.paused.page = 1;
	},
	[API_GET_FOLDERS_PAUSED_SUCCESS]: (state, action) => {
		state.paused.loading = false;
		state.paused.list = action.payload.data.results;
		state.paused.pages = action.payload.data.numberOfPages;
		state.paused.listTotalCount = action.payload.data.totalCount;
		state.paused.prescriptionCount = action.payload.data.prescriptionCount;
		state.paused.page = action.payload.data.page;
	},
	/** GET COUNT */

	[API_GET_FOLDERS_COUNT_FAIL]: (state, action) => {
		state.count = {
			toValidate: 0,
			futures: 0,
			paused: 0,
		};
	},
	[API_GET_FOLDERS_COUNT_SUCCESS]: (state, action) => {
		state.count = action.payload.data;
		state.count.futures = 0;
	},
	[SET_OPEN_TAB]: (state, action) => {
		state.openedTab = action.payload;
	},
	[SET_TV_SEC_MODE]: (state, action) => {
		state.tvSecMode = action.payload;
	},
});

export default secretaryMode;
